// extracted by mini-css-extract-plugin
export default {"container":"login_container__mIg3A","wrapper":"login_wrapper__Nll+x","mainImg":"login_mainImg__eBU0l"};